import { select, put, takeLatest, all } from "redux-saga/effects";
import { createNotification } from "react-redux-notify";
import { push } from "../../helpers/navigation/navigationService";
import {
  fetchCardDetailsSuccess,
  fetchCardDetailsFailure,
  deleteCardSuccess,
  deleteCardFailure,
  selectDefaultCardSuccess,
  selectDefaultCardFailure,
  fetchCardDetailsStart,
  getCardSuccess,
  getCardFailure,
  updateCardSuccess,
  updateCardFailure,
  startCardVerificationDocumentUpload,
} from "../actions/CardsAction";

import api from "../../Environment";
import {
  FETCH_CARD_DETAILS_START,
  DELETE_CARD_START,
  SELECT_DEFAULT_CARD_START,
} from "../actions/ActionConstant";

import {
  getSuccessNotificationMessage,
  getErrorNotificationMessage,
} from "../../components/helper/NotificationMessage";
import { addCardSuccess } from "../actions/CardsAction";
import { addCardFailure } from "../actions/CardsAction";
import { ADD_CARD_START } from "../actions/ActionConstant";
import { verifyCardSuccess } from "../actions/CardsAction";
import { verifyCardFailure } from "../actions/CardsAction";
import { VERIFY_CARD_START } from "../actions/ActionConstant";
import { GET_CARD_START } from "../../store/actions/ActionConstant";
import { UPDATE_CARD_START } from "../../store/actions/ActionConstant";
import { parsePaymentServiceError, parsePaymentServiceErrorData } from "../../helpers/services/payment/error";
import cardService from "../../helpers/services/payment/card";
import { showErrorComponent } from "../actions/ComponentAction";
import { showCardAddressMismatchModal, showCardManualReviewRequiredModal } from "../actions/ModalAction";

function* getCardDetailsAPI() {
  try {
    const response = yield cardService.fetchUserCards()

    yield put(fetchCardDetailsSuccess(response));
  } catch (error) {
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const message = parsePaymentServiceError(error.response);
    yield put(fetchCardDetailsFailure(message));
    const notificationMessage = getErrorNotificationMessage(message);
    yield put(createNotification(notificationMessage));
  }
}

function* getCardDetailAPI() {
  try {
    const card_id = yield select((state) => state.cards.getCardDetails.card_id);
    const response = yield api.postAuthMethod("approvely_get_payment_method", {
      card_id,
    });

    if (response.data.success) {
      yield put(getCardSuccess(response.data.data));
    } else {
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(getCardFailure(response.data.error));
      yield put(createNotification(notificationMessage));
    } 
  } catch (error) {
    yield put(getCardFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* deleteCardAPI() {
  try {
    const deleteCard = yield select((state) => state.cards.deleteCard.data);

    const response = yield cardService.deleteCard(deleteCard?.card_id)

    yield put(deleteCardSuccess(response));
    const notificationMessage = getSuccessNotificationMessage(
      response.message
    );
    yield put(createNotification(notificationMessage));
    yield put(fetchCardDetailsStart());
  } catch (error) {
    yield put(deleteCardFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* updateCardAPI() {
  try {
    let updateCard = yield select((state) => state.cards.updateCard.data);

    const response = yield api.postAuthMethod(
      "approvely_update_payment_method",
      updateCard
    );
    if (response.data.success) {
      yield put(updateCardSuccess(response.data.data));
      const notificationMessage = getSuccessNotificationMessage(
        response.data.message
      );
      yield put(createNotification(notificationMessage));
      yield put(fetchCardDetailsStart());
      yield push("/cards");
    } else {
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(updateCardFailure(response.data.error));
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(updateCardFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* selectDefaultCardAPI() {
  try {
    const selectDefaultCard = yield select(
      (state) => state.cards.selectDefaultCard.inputData
    );

    const response = yield cardService.selectCardAsDefault(selectDefaultCard?.card_id)
    yield put(selectDefaultCardSuccess(response));
    const notificationMessage = getSuccessNotificationMessage("Default Card selected successfully");
    yield put(createNotification(notificationMessage));
    yield put(fetchCardDetailsStart());
  } catch (error) {
    const message = parsePaymentServiceError(error.response);
    yield put(selectDefaultCardFailure(parsePaymentServiceErrorData(error.response)));
    const notificationMessage = getErrorNotificationMessage(message);
    yield put(createNotification(notificationMessage));
  }
}

function* addCardAPI() {
  try {
    const inputData = yield select((state) => state.cards.addCard.inputData);

    const response = yield cardService.createCard(inputData)

    yield put(addCardSuccess(response));
    const notificationMessage = getSuccessNotificationMessage(
      response.message
    );
    yield put(createNotification(notificationMessage));
    yield put(fetchCardDetailsStart());
    yield push("/cards");
  } catch (error) {
    const message = parsePaymentServiceError(error.response);
    const errorData = parsePaymentServiceErrorData(error.response)
    yield put(addCardFailure(message));
    if (errorData && errorData?.is_manual_review_required) {
      // redirect to card verification document form
      yield put(startCardVerificationDocumentUpload(errorData.card_id))
    } else {
      if (message === 'address_mismatch' || message === 'zip_code_missing') {
        // show address mismatch modal
        let errorMessage = message === 'zip_code_missing' ?
         'Your profile address is incomplete as the postal code is missing. To update postal code, head to edit profile page.' : 
         'The address you provided does not match address listed under your profile. To update your address, head to edit profile page.'
        yield put(showCardAddressMismatchModal({
          message: errorMessage
        }))
      } else {
        if (error?.response?.status !== 400) {
          yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
        }
        const notificationMessage = getErrorNotificationMessage(message);
        yield put(createNotification(notificationMessage));
      }
    }
  }
}

function* verifyCardAPI() {
  try {
    const inputData = yield select((state) => state.cards.verifyCard.inputData);

    const response = yield cardService.verifyCard(inputData)

    yield put(verifyCardSuccess(response));
      const notificationMessage = getSuccessNotificationMessage(
        response.message
      );
    yield put(createNotification(notificationMessage));
    yield put(fetchCardDetailsStart());
  } catch (error) {
    const message = parsePaymentServiceError(error.response);
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    yield put(verifyCardFailure(parsePaymentServiceErrorData(error.response)));
    const notificationMessage = getErrorNotificationMessage(message);
    yield put(createNotification(notificationMessage));
  }
}

export default function* pageSaga() {
  yield all([yield takeLatest(FETCH_CARD_DETAILS_START, getCardDetailsAPI)]);
  yield all([yield takeLatest(DELETE_CARD_START, deleteCardAPI)]);
  yield all([
    yield takeLatest(SELECT_DEFAULT_CARD_START, selectDefaultCardAPI),
  ]);
  yield all([yield takeLatest(ADD_CARD_START, addCardAPI)]);
  yield all([yield takeLatest(VERIFY_CARD_START, verifyCardAPI)]);
  yield all([yield takeLatest(GET_CARD_START, getCardDetailAPI)]);
  yield all([yield takeLatest(UPDATE_CARD_START, updateCardAPI)]);
}
